














import { Component, Prop } from 'vue-property-decorator'
import { BaseInput, ICampoTemplate } from './base/BaseInput'

@Component({
  name: 'InputCheckbox'
})
export default class InputCheckbox extends BaseInput {
  @Prop({ required: true })
  campo!: ICampoTemplate

  isChecked(value: string | number): boolean {
    const valores = Array.isArray(this.campo.valor) ? this.campo.valor : []
    return valores.includes(value as any)
  }

  handleCheckboxChange(value: string | number) {
    const valores = Array.isArray(this.campo.valor) ? [...(this.campo.valor as any[])] : []
    const index = valores.indexOf(value as any)

    if (index > -1) {
      valores.splice(index, 1)
    } else {
      valores.push(value as any)
    }

    this.$emit('update', valores)
  }
}
